import { reflectKeys } from "@utils/key.reflactor";

export const HEADERS = {
  TITLE: "title",
  TYPE: "type",
  LOCATION: "location",
  STARRED_DATE: "starredDate",
  ACTION: "action",
};

export const RESOURCE_DOMAIN = {
  MOE: "MOE",
  COMMUNITY: "COMMUNITY",
  PERSONAL: "PERSONAL",
  ALP_TEMPLATE: "ALP_TEMPLATE",
  ASSIGNMENT: "ASSIGNMENT",
  APP: "APP",
};

export const RESOURCE_FAVOURITE_TYPE = reflectKeys(["LESSON", "QUESTION", "MEDIA", "APP"]);

export const FILTER_OPTIONS = {
  RESOURCE: "Resource",
  RESOURCE_TYPE: "Resource Type",
};

export type FilterOptions = keyof typeof FILTER_OPTIONS;

export const RESOURCE_FILTER_OPTIONS = {
  ALL: { label: "search_filter_resource_all", value: "ALL" },
  LESSON: { label: "search_filter_resource_lessons_courses", value: "LESSON" },
  QUESTION: { label: "search_filter_resource_questions", value: "QUESTION" },
  RUBRIC: { label: "search_filter_resource_rubrics", value: "RUBRIC" },
  MEDIA: { label: "search_filter_resource_media", value: "MEDIA" },
  APP: { label: "search_filter_resource_app", value: "APP" },
};

export const QUESTION_RESOURCE_TYPE_FILTER_OPTIONS = {
  MCQ: { label: "search_filter_mcq_label", value: "MCQ" },
  MRQ: { label: "search_filter_mrq_label", value: "MRQ" },
  FILL: { label: "search_filter_fitb_label", value: "FILL" },
  DND: { label: "search_filter_cnd_label", value: "DND" },
  FREE: { label: "search_filter_frq_label", value: "FREE" },
  FILE: { label: "search_filter_fsq_label", value: "FILE" },
  REC: { label: "search_filter_arq_label", value: "REC" },
  EEQ: { label: "search_filter_eeq_label", value: "EEQ" },
  MPQ: { label: "search_filter_mpq_label", value: "MPQ" },
};

export const MEDIA_RESOURCE_TYPE_FILTER_OPTIONS = {
  IMAGE: { label: "search_filter_media_type_image_label", value: "IMAGE" },
  VIDEO: { label: "search_filter_media_type_video_label", value: "VIDEO" },
  HTML5: { label: "search_filter_media_type_interactive_label", value: "HTML5" },
  AUDIO: { label: "search_filter_media_type_audio_label", value: "AUDIO" },
  POWERPOINT: { label: "search_filter_media_type_ppt_label", value: "POWERPOINT" },
  WORD: { label: "search_filter_media_type_word_label", value: "WORD" },
  EXCEL: { label: "search_filter_media_type_excel_label", value: "EXCEL" },
  PDF: { label: "search_filter_media_type_pdf_label", value: "PDF" },
  ZIP: { label: "search_filter_media_type_zip_label", value: "ZIP" },
  OTHERS: { label: "search_filter_media_type_others_label", value: "OTHERS" },
};

export const NAMESPACE = {
  AUTH: "auth",
};
